export function getCompareUrl(basePath, queryParams, cruisesComparing) {
  const searchId = `search=id:${cruisesComparing.map(item => item.id)}`;
  const queryParamsKeys = Object.keys(queryParams);

  if (!queryParamsKeys.length) {
    return `${basePath}?${searchId}`;
  }

  let queryString = queryParamsKeys.reduce((acum, key, index) => `${acum}${index > 0 ? '&' : '?'}${key}=${queryParams[key]}`, '');

  if (queryString.includes('search=')) {
    queryString = queryString.replace('search=', `${searchId}|`);
  } else {
    queryString = queryString.replace('?', `?${searchId}&`);
  }
  
  return `${basePath}${queryString}`;
}